class HeroSection extends HTMLElement {
  connectedCallback() {
    const variant = this.getAttribute('variant') || 'default'; // default, home, showcase
    const titleEn = this.getAttribute('title-en') || '';
    const titleLv = this.getAttribute('title-lv') || '';
    const titleIt = this.getAttribute('title-it') || '';
    const subtitleEn = this.getAttribute('subtitle-en') || '';
    const subtitleLv = this.getAttribute('subtitle-lv') || '';
    const subtitleIt = this.getAttribute('subtitle-it') || '';
    const badgeEn = this.getAttribute('badge-en') || '';
    const badgeLv = this.getAttribute('badge-lv') || '';
    const badgeIt = this.getAttribute('badge-it') || '';
    const titleGradient = this.hasAttribute('title-gradient');

    // Variant-specific classes
    const sectionClass = variant === 'home'
      ? 'relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden theme-background'
      : 'pt-32 pb-20 theme-background';

    const titleClass = variant === 'home'
      ? 'text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight leading-tight mb-8 max-w-5xl mx-auto'
      : variant === 'showcase'
        ? 'text-4xl md:text-6xl font-bold text-slate-900 mb-6'
        : 'text-4xl md:text-5xl font-bold text-slate-900 mb-6';

    const subtitleClass = variant === 'home'
      ? 'text-lg md:text-xl text-slate-600 max-w-3xl mx-auto mb-10 leading-relaxed'
      : 'text-xl text-slate-700 max-w-3xl mx-auto mb-8';

    // Background decoration for home variant
    const backgroundDecoration = variant === 'home' ? `
      <div class="absolute inset-0 z-0">
        <div class="absolute inset-0 bg-gradient-to-br from-slate-50 to-indigo-50/50"></div>
        <div class="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-indigo-100/20 to-transparent transform skew-x-12"></div>
      </div>
    ` : '';

    // Badge/pill element
    const badgeHtml = badgeEn ? (variant === 'home' ? `
      <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-50 border border-indigo-100 text-indigo-700 text-sm font-medium mb-8 animate-fade-in-up">
        <span class="relative flex h-2 w-2">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
        </span>
        <span data-en="${badgeEn}" data-lv="${badgeLv}" data-it="${badgeIt}">${badgeEn}</span>
      </div>
    ` : `
      <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-50 border border-indigo-100 text-indigo-700 text-sm font-medium mb-8">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <span data-en="${badgeEn}" data-lv="${badgeLv}" data-it="${badgeIt}">${badgeEn}</span>
      </div>
    `) : '';

    // Title with optional gradient
    const titleSpanClass = titleGradient ? 'text-gradient fade-text' : '';
    const titleHtml = `
      <h1 class="${titleClass}">
        <span class="${titleSpanClass}" data-en="${titleEn}" data-lv="${titleLv}" data-it="${titleIt}">${titleEn}</span>
      </h1>
    `;

    // Subtitle (uses data-attributes directly on p element for home variant)
    const subtitleHtml = subtitleEn ? (variant === 'home' ? `
      <p class="${subtitleClass}" data-en="${subtitleEn}" data-lv="${subtitleLv}" data-it="${subtitleIt}"></p>
    ` : `
      <p class="${subtitleClass}">
        <span data-en="${subtitleEn}" data-lv="${subtitleLv}" data-it="${subtitleIt}">${subtitleEn}</span>
      </p>
    `) : '';

    const containerClass = variant === 'home'
      ? 'container mx-auto px-6 relative z-10 text-center'
      : 'container mx-auto px-6 text-center';

    this.innerHTML = `
      <section class="${sectionClass}">
        ${backgroundDecoration}
        <div class="${containerClass}">
          ${badgeHtml}
          ${titleHtml}
          ${subtitleHtml}
          <slot></slot>
        </div>
      </section>
    `;
  }
}

customElements.define('hero-section', HeroSection);

